import React, { useState, PureComponent, useEffect,useRef } from "react";
import { Link } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import Carousel from 'react-bootstrap/Carousel';
import "../App.css";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import Header from "./header";
import SideNav from "./sidenav";
import Action1 from "../assets/images/Action-1.png";
import { Button } from "react-bootstrap";
import Back from "../assets/images/arrow2.png";
import Pagination from "react-js-pagination";
import { useDispatch, useSelector } from "react-redux";
import { productReportAction } from "../redux/actions/reportAction";
const init = {
productFinalData:[]
}
const ReportProduct = () => {
    const tableRef = useRef(null);
   const[iState, updateState] = useState(init);
   const {productFinalData} = iState;
   const dispatch = useDispatch();
   const [activePage, updateActivePage] = useState(1);
   const [serialNo, updateSerialNo] = useState(10);
   const {productReportData} = useSelector((state) => state.dashboard);
   const ownerData = JSON.parse(window.localStorage.getItem("ownerLogin"));
   useEffect(() => {
      dispatch(productReportAction({storeId:ownerData?._id}))
   },[])
   useEffect(() =>{
       updateState({...iState, productFinalData:productReportData?.data?.result})
   },[productReportData])
   const handlePageChange = (pageNumber) => {
    let ser = pageNumber * 10;
    updateSerialNo(ser);
    updateActivePage(pageNumber);
    dispatch(productReportAction({storeId:ownerData?._id,page:pageNumber}))
  };

    return (
        <div>
            <Header />
            <SideNav />
            <div class="WrapperArea">
                <div class="WrapperBox">
                    <div class="TitleBox">
                        <div>
                            <h4 class="Title"> <Link to="/Report-management" > <img src={Back} /></Link> Product  Reports</h4>
                        </div>
                        <DownloadTableExcel
                    filename="Product Report List"
                    sheet="Product Report List"
                    currentTableRef={tableRef.current}
                >

                   <button  className="DownloadExcel"> Export excel </button>

                </DownloadTableExcel>
                        {/* <button className="DownloadExcel" >Export to Excel </button> */}
                    </div>
                    <div className="Small-Wrapper">
                     
                        <div class="TableList">
                            <table  ref={tableRef}  style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                    <th>NO.</th>
                                        <th>Product  ID</th>
                                        <th>Product  Name</th>
                                        <th>Total Sold</th>
                                        <th>Total Earning</th>
                                        <th>Status</th>
                                     
                                    </tr>
                                </thead>
                                <tbody >
                                {productFinalData && productFinalData?.length > 0 ? 
                                   <>
                                   {productFinalData?.map((ele, index) => {
                                    return(
                                        <>
                                          <tr>
                                          <td>{index + 1 + serialNo - 10}</td>
                                        <td>{ele?.product_number}</td>
                                        <td>{ele?.product_name}</td>
                                        <td>{ele?.total_sold}</td>
                                        <td>{ele?.total_earnings}</td>
                                        <td><span class="Orange">{ele?.status}</span></td>
                                     
                                    </tr>
                                        
                                        </>
                                    )
                                   })}
                                   </> 
                                   :
                                   <>  <h2 className="NoDataFound">NO DATA FOUND</h2></>
                                }



                                
                                  
                                </tbody>
                            </table>
                        </div>
                        <div class="Pagination">
              <p>
                {" "}
                Total records : <span> {productReportData?.data?.total}</span>
              </p>
              <ul>
                {productReportData?.data?.total && (
                  <Pagination
                    activePage={activePage}
                    itemsCountPerPage={10}
                    totalItemsCount={productReportData?.data?.total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item"
                    linkClass="page-link"
                  />
                )}
              </ul>
            </div>
                    </div>

                </div>
            </div>

        </div>

    );
}
export default ReportProduct